import styled from "@emotion/styled";
import { css } from "@emotion/react";
import DeungiHeader from "@src/components/deungi/DeungiHeader";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import LandRegisterPackageListBox from "./LandRegisterPackageListBox";
import { IssueLandRegisterResponseDto, useIssueLandRegister } from "@src/hooks/landRegister/useLandRegister";
import { dialogTitleStyle, LAND_REGISTER_ERROR_MODAL_TYPE } from "./LandRegisterMain";
import ConfirmModal from "@src/components/popup/ConfirmModal";
import { WebAppBridge } from "@src/lib/WebAppBridge";

const LandRegisterPayment = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const inflow = searchParams.get("inflow");
    const { mutate: issueLandRegister } = useIssueLandRegister();
    const [isOpenConfirmModal, setIsOpenConfirmModal] = useState<LAND_REGISTER_ERROR_MODAL_TYPE>(
        LAND_REGISTER_ERROR_MODAL_TYPE.닫기,
    );
    const [errorMessage, setErrorMessage] = useState("");
    const [errorTitle, setErrorTitle] = useState("");

    const goToIssueStatusPage = (issued: IssueLandRegisterResponseDto) => {
        navigate({
            pathname: "/landRegister/status",
            search: `?id=${issued._id}&address=${issued.address}`,
        });
    };

    const handlePaymentSuccess = async () => {
        const selectedLandRegister = localStorage.getItem("selectedLandRegister");
        if (selectedLandRegister) {
            const { pnu } = JSON.parse(selectedLandRegister);
            issueLandRegister(
                { pnu },
                {
                    onSuccess: (data) => {
                        goToIssueStatusPage(data);
                        localStorage.removeItem("selectedLandRegister");
                    },
                    onError: (error) => {
                        localStorage.removeItem("selectedLandRegister");
                        setIsOpenConfirmModal(LAND_REGISTER_ERROR_MODAL_TYPE.발급실패);
                        setErrorMessage(error.message);
                    },
                },
            );
        }
    };

    WebAppBridge.onPaymentSuccess = () => {
        if (inflow) {
            handlePaymentSuccess();
        } else {
            navigate("/landRegister");
        }
    };
    return (
        <Container>
            <DeungiHeader title="충전하기" />
            <div className="box">
                <LandRegisterPackageListBox />
            </div>
            {isOpenConfirmModal === LAND_REGISTER_ERROR_MODAL_TYPE.발급실패 && (
                <ConfirmModal
                    resultMessage={
                        <>
                            <p css={dialogTitle}>{errorTitle}</p>
                            <p css={dialogTitleStyle}>{errorMessage}</p>
                        </>
                    }
                    buttonText="확인"
                    onConfirm={() => {
                        navigate("/landRegister");
                    }}
                />
            )}
        </Container>
    );
};

const Container = styled.div`
    position: relative;
    height: 100vh;
    height: calc(var(--vh, 1dvh) * 100);
    animation: fadeIn 0.5s forwards;
    background-color: white;

    .box {
        position: absolute;
        top: 56px;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        overflow: auto;
        overscroll-behavior-y: none;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

const dialogTitle = css`
    color: #0c002c;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    margin: 0px 0 14px;
`;

export default LandRegisterPayment;
